import React from 'react';
import { contact, section5Title } from '../../profile';

const Contact = () => {
    return (
        <div className="parallax">
            <div data-aos="zoom-in-up" data-aos-once="true" className="git-form">
                <div className="git-head-div text-center mx-auto">
                    <h1 id="Contact" className="git-head">{section5Title}</h1>
                </div>
                <div className="container">
                    <div
                        style={{
                            display: 'flex',
                            flexDirection: 'column',
                            alignItems: 'center',
                            justifyContent: 'center',
                            width: '100%',
                            textAlign: 'center',
                        }}
                    >
                        <p style={{ padding: '3rem 1rem 0', textAlign: 'center', fontSize: '1.1rem', margin: 0 }}>
                            {contact.pitch}
                        </p>
                        <div style={{ paddingTop: '1.5rem', display: 'flex', justifyContent: 'center', width: '100%' }}>
                            <a
                                href="mailto:sharifchoudhury7@gmail.com"
                                title="Email"
                                style={{ color: 'var(--primary-color)', fontSize: '2.2rem', transition: '0.3s' }}
                                onMouseEnter={e => (e.currentTarget.style.color = 'var(--hover-color)')}
                                onMouseLeave={e => (e.currentTarget.style.color = 'var(--primary-color)')}
                            >
                                <i className="fas fa-envelope"></i>
                            </a>
                        </div>
                    </div>
                </div>
            </div>
            <p id="not-dark" className="Copy">
                2026 &copy; Copyright <strong>{contact.copyright}</strong>. All Rights Reserved
            </p>
        </div>
    );
};

export default Contact;
